"use client";

import * as React from "react";
export default function CustomerTestimonials() {
  return null;
}